<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-12-03 14:16:15
 * @LastEditTime : 2019-12-19 22:10:42
 * @LastEditors  : 山淑兰
 -->
<template>
  <div id="upaycallback">
    <div class="tipsPupop">
      <van-dialog v-model="tipsPupop.showTips" title="错误" show-cancel-button>
        <div class="tipsPupop_content">
          <h2>{{tipsPupop.code}}</h2>
          <p>{{tipsPupop.msg}}</p>
        </div>
      </van-dialog>
      <div class="tips-box" v-if="tipsVisible">
          <div class="tips-con">
              <div class="tips-group">
                  <div class="tips-group-btn" @click="goPerson()">
                      订单支付成功
                  </div>
                  <div class="tips-group-btn" @click="goPerson()">
                      订单支付失败
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "upaycallback",
  data() {
    return {
      tipsPupop: {    //code提示弹框
        showTips: false,
        code: '',
        msg: "",
        m: "",
        Orderid: '',
      },
      tipsVisible: false
    }
  },
  created() {
    this.m = this.$route.query.m
    this.Orderid = this.getQueryStringRegExp("requestId").split("#")[0]
    console.log(this.$route.query)
    let opt = {
      m: this.m,
      "PayType": 1,
      "PayCode": "5upay",
      "Orderid": this.Orderid
    }
    this.init(opt)
  },

  methods: {
    getQueryStringRegExp(name){
      var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href)) return unescape(RegExp.$2.replace(/\+/g, " ")); return "";
    },
    async init(opt) {
      try {
        let res = await this.$http.PayOrderCallBack(opt)
        this.tipsVisible = true
        if (res.Code === 1000) {
          console.log(res)
        } else {
          console.log(res)
          // this.tipsPupop = {
          //   showTips: true,
          //   code: 'code:' + res.Code,
          //   msg: 'Msg:' + res.Msg,
          // }
        }
      } catch (err) {
        console.log(err)
      }

    },
    goPerson(){
      this.tipsVisible = false
      window.location.href = 'https://mp.weiqihd.com/mpweb/#/signup/signupinfo?m='+this.$route.query.m+''
      // this.$router.push({
      //   path: 'https://mp.weiqihd.com/mpweb/#/signup/signupinfo',
      //   query: {
      //     m: this.$route.query.m,
      //   }
      // })
    },
  },

}

</script>

<style  lang="scss">
.van-dialog {
  width: 70%;
  text-align: center;
  font-size: 32px;
  padding-top: 20px;
  .van-dialog__content {
    margin: 20px;
  }
  .van-button {
    font-size: 32px;
    line-height: 60px;
    height: 60px;
  }
}
.tips-box{
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 999;
      background: rgba(0,0,0,.5);
      .tips-con{
          position: absolute;
          width: 60%;
          height: 160px;
          background: #fff;
          padding: 20px 0;
          top: 50%;
          left: 50%;
          z-index: 1000;
          transform: translate(-50%,-50%);
          font-size: 30px;
          text-align: center;
          border-radius: 12px;
          overflow: hidden;
          .tips-group{
              height: 80px;
              >div{
                  line-height: 90px;
                  color: #475569;
              }
              >div:first-child{
                color: #3b82f6;
              }
              >div:last-child{
                color: #f56c6c;
              }
          }
      }
  }
</style>